/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import CompetitionQueryResult from './CompetitionQueryResult';

/**
 * The CompetitionOutputCmsCompetitions model module.
 * @module model/CompetitionOutputCmsCompetitions
 * @version 1.0
 */
class CompetitionOutputCmsCompetitions {
    /**
     * Constructs a new <code>CompetitionOutputCmsCompetitions</code>.
     * @alias module:model/CompetitionOutputCmsCompetitions
     */
    constructor() { 
        
        CompetitionOutputCmsCompetitions.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CompetitionOutputCmsCompetitions</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CompetitionOutputCmsCompetitions} obj Optional instance to populate.
     * @return {module:model/CompetitionOutputCmsCompetitions} The populated <code>CompetitionOutputCmsCompetitions</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CompetitionOutputCmsCompetitions();

            if (data.hasOwnProperty('competitions')) {
                obj['competitions'] = ApiClient.convertToType(data['competitions'], [CompetitionQueryResult]);
            }
        }
        return obj;
    }


}

/**
 * @member {Array.<module:model/CompetitionQueryResult>} competitions
 */
CompetitionOutputCmsCompetitions.prototype['competitions'] = undefined;






export default CompetitionOutputCmsCompetitions;

